module.exports = __webpack_public_path__ + "static/media/Milex-Shaatz-Pessary-Instructions-for-Use@3x.0fad39eb.jpg";